<template>
  <div class="content if-profile">
    <MPHeader v-if="headerData" :headerData="this.headerData" />
    <div class="md-layout ratios-report">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 marketprof-competitors p-0">
        <!-- <div class="finanical-report-messages">
          <h1 class="md-subheading profile-title">Industry Branch Concentration</h1>
          <div class="">
            <md-dialog :md-active.sync="showDialog">
              <p>Is this industry becoming more subject to outside ownership decisions in your area? Are local entrepreneurs being squeezed out by
                franchises or branch operations? <br> <br>
                This table shows the percentage of industry branch operations in the US and your market area as a barometer of relative
                consolidation trends. Increasing branch level may indicate pressure on area entrepreneurship.
              </p>
            </md-dialog>
            <md-card-header class="md-card-header-icon messages-box">
              <div class="card-icon md-ripple" @click="showDialog = true">
                <md-icon class="icon-arrow">double_arrow </md-icon>
                <md-icon>help</md-icon>
              </div>
            </md-card-header>
          </div>
        </div>-->
        <div class="md-card m-0">
          <div class="md-transparent finanical-report-messages">
            <nav-tabs-card class="p-0 m-0">
              <template slot="content">
                <md-card class="if_card">
                  <md-card-header>Industry Branch Concentration</md-card-header>
                  <md-card-content>
                    <div class="md-layout p-4">
                      <div class="md-layout-item md-size-100 blue-tbl">
                        <md-card class="md-card-profile">
                          <md-card-header>
                            <h4 class="title m-0">
                              <div
                                class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                              >Industry Branch Concentration (%)</div>
                            </h4>
                          </md-card-header>
                          <md-card-content>
                            <div class="md-layout">
                              <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
                                <md-table
                                  v-model="tableDataBranchConcentration"
                                  table-header-color="blue"
                                  class="profit-and-loss-table"
                                >
                                  <md-table-row slot="md-table-row" slot-scope="{ item }">
                                    <md-table-cell class="md-table-side-label">{{ item.name }}</md-table-cell>
                                    <md-table-cell
                                      v-for="key in Object.keys(item.dates)"
                                      :key="key"
                                      :md-label="years[key]"
                                    >{{ item.dates[key] }}</md-table-cell>
                                  </md-table-row>
                                </md-table>
                              </div>
                            </div>
                          </md-card-content>
                        </md-card>
                      </div>
                      <div class="md-layout-item md-medium-size-100 md-size-50">
                        <md-card class="md-card-profile">
                          <md-card-content>
                            <chart-card
                              header-animation="false"
                              :chart-data="colouredLineChart.data"
                              :chart-options="colouredLineChart.options"
                              chart-type="Line"
                              header-icon
                              chart-inside-content
                              no-footer
                              background-color="blue"
                            >
                              <template slot="chartInsideHeader">
                                <h4 class="title m-0">
                                  <div
                                    class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                  >Industry Branch Concentration (%)</div>
                                </h4>
                                <!-- <h4 class="title">Industry Branch Concentration (%)</h4> -->
                              </template>
                            </chart-card>
                            <div class="pie-line" v-if="colouredLineChart && colouredLineChart.data && colouredLineChart.data.series">
                              <ul>
                                <li v-for="(label, index) in colouredLineChart.data.series" :key="index + '_label'"><span class=""><i :class="'fa fa-square ' + 'chart-label-color-' + index"></i></span> {{ label.name }}</li>
                              </ul>
                            </div>
                          </md-card-content>
                        </md-card>
                      </div>
                      <div class="md-layout-item md-medium-size-100 md-size-50">
                         <md-card class="md-card-profile">
                          <md-card-header>
                            <h4 class="title m-0">
                              <div
                                class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                              >Competitive Market Narrative</div>
                            </h4>
                          </md-card-header>
                          <md-card-content>
                            <div class="extra_space">
                              <!-- <h4 class="Performance Scores">
                                Competitive Market Narrative
                              </h4>-->
                              <p>
                                     {{cmnText.ownership}}
                              </p>
                            </div>
                          </md-card-content>
                        </md-card>
                      </div>
                      <div class="md-layout-item md-medium-size-100 md-size-50">
                        <md-card class="md-card-profile">
                            <md-card-header>
                              <h4 class="title m-0">
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                >
                                  <md-icon class="color-white">article</md-icon> Ownership
                                </div>
                              </h4>
                            </md-card-header>
                            <md-card-content>
                              <div class="md-layout">
                                <div class="md-layout-item md-medium-size-100 md-size-100">
                                  <div class="extra_space">
                                    <!-- <h4 class="Performance Scores">
                                          Competitive Market Narrative
                                    </h4>-->
                                    <p>
                                      Is this industry becoming more subject to outside ownership decisions in your area?
                                      Are local entrepreneurs being squeezed out by franchises or branch operations?<br><br>
                                      This table shows the percentage of industry branch operations in the US and your market
                                      area as a barometer of relative consolidation trends. Increasing branch level may indicate
                                      pressure on area entrepreneurship.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </md-card-content>
                          </md-card>
                      </div>
                    </div>
                  </md-card-content>
                </md-card>
              </template>
            </nav-tabs-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MPHeader from './MPHeader';
import { ChartCard, NavTabsCard } from '@/components';
import { mapState } from 'vuex';

export default {
  components: {
    ChartCard,
    NavTabsCard,
    MPHeader,
  },

  data() {
    return {
      showDialog: false,
      tableDataBranchConcentration: [],
      colouredLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          showPoint: true,
          height: '300px',
        },
      },
      filtered_population: [],
      filtered_market_volume: [],
      filtered_market_share: [],
      filtered_annual_sales: [],
      filtered_penetration: [],
      filtered_employment: [],
      filtered_market_by_class: [],
      filtered_market_percent_by_class: [],
      filtered_average_sale_by_class: [],
      filtered_establishment_by_class: [],
      filtered_total_employment_by_class: [],
      filtered_average_employment_by_class: [],
      filtered_annual_sales_per_employee: [],
      filtered_average_annual_wage: [],
      filtered_rent_per_employee: [],
      filtered_startup_info: [],
      filtered_cessation_info: [],
      filtered_ownership_info: [],
      filtered_demographic_info: [],
    };
  },
  computed: {
    ...mapState({
      ownership: (state) => state.user.industryProfile.data['ownership'],
      years: (state) => state.user.industryProfile.firstYears,
      release_years: (state) =>
        state?.user?.industryProfile?.general?.release_years,
      cessation: (state) => state.user.industryProfile.data['cessation'],
      chartData: (state) =>
        state.user.industryProfile.charts.test['Cessation'][0],
      salesEmpSales: (state) =>
        state.user.industryProfile.data['salesEmpSales'],
      salesEmpCols: (state) => state.user.industryProfile['salesEmpCols'],
      salesEmpEmployment: (state) =>
        state.user.industryProfile.data['salesEmpEmployment'],
      tableCompetitors: (state) =>
        state.user.industryProfile.data['competitors'],
      bznaics_code: (state) => state?.user?.industryProfile?.general?.bznaics,
      sector_name: (state) => state?.user?.industryProfile?.general?.sector,
      industry_title: (state) => state?.user?.industryProfile?.general?.industry,
      release_display: (state) =>
        state?.user?.industryProfile?.general?.['release_display'],
      update_month: (state) => state.user.industryProfile.updateMonth,
      display_area: (state) =>
        state?.user?.industryProfile?.general?.area_display_name,
      marketVolume: (state) => state.user.industryProfile.data['marketVolume'],
      marketShare: (state) => state.user.industryProfile.data['marketShare'],
      annualSales: (state) => state.user.industryProfile.data['annualSales'],
      annualSalesCols: (state) => state.user.industryProfile['annualSalesCols'],
      penetration: (state) => state.user.industryProfile.data['penetration'],
      employment: (state) => state.user.industryProfile.data['employment'],
      productivity: (state) =>
        state.user.industryProfile.data['productivityValues'],
      startupPerformance: (state) =>
        state.user.industryProfile.data['startupsValues'],
      startupRates: (state) => state.user.industryProfile.data['startupsIndex'],
      demographics: (state) => state.user.industryProfile.data['demographics'],

      cmnText: (state) =>state.user.cmnText,
      cessation_years: (state) => state?.user?.industryProfile?.general?.cessation_years,
    }),
    cessationLabel() {
      return this.cessation_years && this.cessation_years.length === 2
        ? `${this.cessation_years[0]}-${this.cessation_years[1]} Cessation Rates`
        : 'Cessation Rates';
    },
    getCsvData() {
      let csvData = [
        ['Bizminer Local Industry Market Report'],
        [this.bznaics_code, this.industry_title],
        ['Sector: ' + this.sector_name],
        [this.display_area],
        [
          'Data Time Series',
          this.release_years.toString() + '-' + this.update_month,
        ],
        ['Update Month', this.update_month],
        [''],
      ];
      csvData.push(['Industry Population Analyzed'], ['as of:', this.years]);
      this.filtered_population.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(
        [''],
        ['Annual Industry Market Volume($)'],
        ['as of:', this.years]
      );
      this.filtered_market_volume.forEach((e, i) => {
        e.forEach((k, i) => {
          if (typeof k === 'string' && k.includes('.')) {
            e[i] = k.replace(/\./g, '');
          }
        });
        csvData.push(e);
      });
      csvData.push([''], ['Share(%)'], ['', this.years]);
      this.filtered_market_share.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push([''], [''], ['Average Annual Sales']);
      csvData.push(['', this.annualSalesCols]);
      this.filtered_annual_sales.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Rank'], ['as of:', this.years]);
      csvData.push([''], [''], [''], [''], ['']);
      csvData.push(['Market Penetration ($)']);
      csvData.push(['', this.years]);
      this.filtered_penetration.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(
        [''],
        [
          'To enhance report load times Sales per Business Establishment values are reported in the IMR-2 file accessible from the My Reports page after you refresh the browser',
        ]
      );
      csvData.push([''], ['']);
      csvData.push(['Employment', this.years]);
      this.filtered_employment.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push([''], ['']);
      csvData.push(['Market Volume by Employment Class', this.years]);
      this.filtered_market_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push(
        [''],
        ['Percent Market Volume by Employment Class', this.years]
      );
      this.filtered_market_percent_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Average Sales by Employment Class', this.years]);
      this.filtered_average_sale_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Establishments by Employment Class', this.years]);
      this.filtered_establishment_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Total Employment by Class', this.years]);
      this.filtered_total_employment_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Average Employment by Class', this.years]);
      this.filtered_average_employment_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Productivity']);
      csvData.push(['Annual Sales per Employee', this.years]);
      this.filtered_annual_sales_per_employee.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], ['']);
      csvData.push(['Average Annual Wage', this.years]);
      this.filtered_average_annual_wage.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], ['']);
      csvData.push(['Rent per Employee', this.years]);
      this.filtered_rent_per_employee.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], ['']);
      csvData.push(['Productivity Indices (%)', this.years]);
      csvData.push([''], [''], [''], [''], ['']);
      csvData.push(['Startup Activity and Performance']);
      csvData.push(['', this.years]);
      this.filtered_startup_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], [''], ['']);
      csvData.push(
        [
          'To enhance report load times Concentration values are reported in the IMR-2 file accessible from the My Reports page after you refresh the browser',
        ],
        [''],
        [''],
        [''],
        [''],
        [this.cessationLabel]
      );
      this.filtered_cessation_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], ['Ownership/Consolidation Trends', this.years]);
      this.filtered_ownership_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], ['Market Area Demographic Highlights']);
      csvData.push([
        '(based on zip codes co-joined with your market radius) (2015)',
      ]);
      this.filtered_demographic_info.forEach((element, index) => {
        element.forEach((el, i) => {
          csvData.push(el);
        });
        csvData.push(['']);
      });
      return csvData;
    },
  },
  mounted() {
    this.tableDataBranchConcentration = Object.entries(
      this.ownership
    ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));

    this.colouredLineChart.data = {
      labels: this.years,
      series: this.tableDataBranchConcentration.map((item) => ({
        name: item.name,
        data: item.dates.map((i) => Number(i)),
      })),
    };
    let me = this;
    let populationData = Object.entries(this.tableCompetitors).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    populationData.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      this.filtered_population.push(r);
    });

    let marketVolume = Object.entries(this.marketVolume).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    marketVolume.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithCommas(e);
      });
      return item;
    });
    let modifiedArr = [];
    marketVolume.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      modifiedArr.push(r);
    });
    modifiedArr.forEach((el) => {
      let modified = el.map(function (el) {
        if (typeof el === 'string' && el.includes(',')) {
          return el.replace(/,/g, '.');
        }
        return el;
      });
      this.filtered_market_volume.push(modified);
    });
    let marketShare = Object.entries(this.marketShare).map(([table, data]) => ({
      name: table,
      dates: Object.values(data),
    }));
    marketShare.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      this.filtered_market_share.push(r);
    });
    this.filtered_market_share = this.filtered_market_share.filter(
      (item, index) => {
        return !item.includes('Your Firm');
      }
    );
    let tableAnnual = Object.entries(this.annualSales).map(([table, data]) => ({
      name: table,
      dates: Object.values(data),
    }));
    tableAnnual.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    tableAnnual.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      this.filtered_annual_sales.push(r);
    });
    this.filtered_annual_sales = this.filtered_annual_sales.filter(
      (item, index) => {
        if (!item.includes('Your Firm')) {
          return item;
        }
      }
    );
    let penetrationData = Object.entries(this.penetration).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    penetrationData.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    penetrationData.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      this.filtered_penetration.push(r);
    });
    let employmentData = Object.entries(this.employment).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    employmentData.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      this.filtered_employment.push(r);
    });
    this.filtered_employment = this.filtered_employment.filter(
      (item, index) => {
        return !item.includes('Your Firm');
      }
    );
    let marketVolumeByClass = Object.entries(
      this.salesEmpSales.marketVolume
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      marketVolumeByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_market_by_class.push(b);
    });
    let marketPercentVolumeByClass = Object.entries(
      this.salesEmpSales.percentMarket
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      marketPercentVolumeByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_market_percent_by_class.push(b);
    });
    let averageSaleByClass = Object.entries(
      this.salesEmpEmployment.average
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      averageSaleByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_average_sale_by_class.push(b);
    });
    let establishmentByClass = Object.entries(
      this.salesEmpEmployment.establishments
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      establishmentByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_establishment_by_class.push(b);
    });
    let totalEmploymentByClass = Object.entries(
      this.salesEmpEmployment.total
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      totalEmploymentByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_total_employment_by_class.push(b);
    });
    let averageEmploymentByClass = Object.entries(
      this.salesEmpEmployment.average
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      averageEmploymentByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_average_employment_by_class.push(b);
    });
    let annualSalesPerEmployee = Object.entries(
      this.productivity.spe
    ).map(([name, data]) => ({ name, dates: data }));
    annualSalesPerEmployee.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    annualSalesPerEmployee.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_annual_sales_per_employee.push(r);
    });
    this.filtered_annual_sales_per_employee = this.filtered_annual_sales_per_employee.filter(
      (item, index) => {
        return !item.includes('Your Firm');
      }
    );
    let averageAnnualWage = Object.entries(
      this.productivity.annualWage
    ).map(([name, data]) => ({ name, dates: data }));
    averageAnnualWage.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    averageAnnualWage.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_average_annual_wage.push(r);
    });
    this.filtered_average_annual_wage = this.filtered_average_annual_wage.filter(
      (item, index) => {
        return !item.includes('Your Firm');
      }
    );
    let rentPerEmployee = Object.entries(
      this.productivity.rent
    ).map(([name, data]) => ({ name, dates: data }));
    rentPerEmployee.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    rentPerEmployee.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_rent_per_employee.push(r);
    });
    this.filtered_rent_per_employee = this.filtered_rent_per_employee.filter(
      (item, index) => {
        return !item.includes('Your Firm');
      }
    );
    let startupPerformance = Object.entries(this.startupPerformance).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    startupPerformance.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    startupPerformance.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_startup_info.push(r);
    });
    let startupRates = Object.entries(this.startupRates).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    startupRates.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    startupRates.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_startup_info.push(r);
    });
    let cessationRates = Object.entries(this.cessation).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    cessationRates.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_cessation_info.push(r);
    });
    let ownerShip = Object.entries(this.ownership).map(([table, data]) => ({
      name: table,
      dates: Object.values(data),
    }));

    ownerShip.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_ownership_info.push(r);
    });

    let demographicInfo = Object.entries(this.demographics).map(
      ([table, data]) => ({
        name: table,
        data: Object.values(data),
      })
    );
    demographicInfo.forEach((element, index) => {
      this.filtered_demographic_info[index] = [];
      this.filtered_demographic_info[index].push([element.name]);
      element.data.forEach((el, i) => {
        Object.keys(el).forEach((key) => {
          let a = el[key];
          a = a.map((e) => {
            if (typeof e === 'string' && e.includes(',')) {
              return me.numberWithPoints(e);
            } else {
              return e;
            }
          });
          if (!a.includes(key)) {
            a.unshift(key);
          }
          this.filtered_demographic_info[index].push(a);
        });
      });
    });

  },
  methods: {
    numberWithCommas(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      } else {
        return x;
      }
    },
     numberWithPoints(x) {
      if (typeof x === 'number') {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      } else if(x === null){
        return x;
      }else
      {
        return x.replace(/,/g, '.');
      }
    },
    downloadCSVData() {
      let csv = '';
      this.getCsvData.forEach((row) => {
        csv += row.join(',');
        csv += '\n';
      });
      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      anchor.download = 'Industry Market Profile.csv';
      anchor.click();
    },
  },
};
</script>
<style lang="scss">
.marketprof-competitors {
  .md-toolbar {
    .md-collapse {
      display: block;

      .md-collapse-content {
        p {
          padding-left: 20px;
        }
      }
    }
  }

  .competitors-list {
    .md-collapse-title {
      font-size: 12px;
      font-weight: 300;
      margin-left: 25px;
    }
    .md-icon {
      font-size: 12px;
      font-weight: 300;
      transform: rotate(-90deg);
      left: 0;
      color: rgba(0, 0, 0, 0.54);
    }
  }

  .competitors-map {
    iframe {
      height: 300px !important;
    }
  }
}
</style>
<!--<template>
  <div class="content if-profile">
    <div class="md-layout ratios-report">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header">
        <div class="md-layout">
          <div class="md-layout-item md-medium-size-65 md-xsmall-size-100 md-size-45">
            <collapse
                :collapse="['Industry Market Profile']"
                icon="keyboard_arrow_down"
                color-collapse="info"
                :active="false">
              <template slot="md-collapse-pane-1">
                <div class="financal-report-col-1">
                  <div>
                    <small>
                      [{{ parseInt(this.bznaics_code) }}] {{ this.industry_title }}<br/>
                      Sector: {{ this.sector_name }}<br/>
                      {{ this.display_area }} <br>
                    </small>
                  </div>
                  <div class="md-layout-item md-medium-size-15 md-xsmall-size-20 md-xsmall-size-20 md-size-15">
                    <img src="/img/image_placeholder.jpg"/>
                  </div>
                </div>
              </template>
            </collapse>
          </div>
          <div class="md-layout-item md-medium-size-35 md-xsmall-size-100 md-size-55 button-box" >
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-40 financal-report-col-2" >
              <div class="md-layout financal-report-col-3">
                <div class="md-layout-item md-medium-size-50 md-small-size-100 md-xsmall-size-100 md-size-50">
                  <md-button
                      class="md-info md-block access-button"
                      v-on:click="downloadCSVData"
                  >CSV <md-icon class="ml-5">table_rows</md-icon>
                  </md-button>
                </div>
                <div class="md-layout-item md-medium-size-50 md-small-size-100 md-xsmall-size-100 md-size-50">
                  <md-button
                      class="md-info md-block access-button"
                      :href="'/'"
                      target="_blank"
                  >PDF <md-icon class="ml-5">picture_as_pdf</md-icon>
                  </md-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 marketprof-competitors">
        <div class="finanical-report-messages">
          <h1 class="md-subheading profile-title">Industry Branch Concentration</h1>
          <div class="">
            <md-dialog :md-active.sync="showDialog">
              <p>Is this industry becoming more subject to outside ownership decisions in your area? Are local entrepreneurs being squeezed out by
                franchises or branch operations? <br> <br>
                This table shows the percentage of industry branch operations in the US and your market area as a barometer of relative
                consolidation trends. Increasing branch level may indicate pressure on area entrepreneurship.
              </p>
            </md-dialog>
            <md-card-header class="md-card-header-icon messages-box">
              <div class="card-icon md-ripple" @click="showDialog = true">
                <md-icon class="icon-arrow">double_arrow </md-icon>
                <md-icon>help</md-icon>
              </div>
            </md-card-header>
          </div>
        </div>
        <div class=" md-transparent finanical-report-messages">
          <nav-tabs-card >
            <template slot="content">
              <div class="md-layout">
                <div class="md-layout-item md-size-100">
                  <md-card>
                    <md-card-header class="md-card-header-icon">
                      <div class="card-icon">
                        <md-icon>money</md-icon>
                      </div>
                      <h4 class="title text-left">Industry Branch Concentration (%)</h4>
                    </md-card-header>
                    <md-card-content>
                      <div class="md-layout">
                        <div class="md-layout-item md-medium-size-100 md-size-100">
                          <md-table
                              v-model="tableDataBranchConcentration"
                              table-header-color="blue"
                              class="profit-and-loss-table">
                            <md-table-row
                                slot="md-table-row"
                                slot-scope="{ item }">
                              <md-table-cell class="md-table-side-label">{{ item.name }}</md-table-cell>
                              <md-table-cell v-for="key in Object.keys(item.dates)"
                                             :key="key"
                                             :md-label="years[key]">{{ item.dates[key] }}
                              </md-table-cell>
                            </md-table-row>
                          </md-table>
                        </div>
                      </div>
                    </md-card-content>
                  </md-card>
                </div>
                <div class="md-layout-item md-medium-size-50 md-size-50">
                  <chart-card
                      header-animation="false"
                      :chart-data="colouredLineChart.data"
                      :chart-options="colouredLineChart.options"
                      chart-type="Line"
                      header-icon
                      chart-inside-content
                      no-footer
                      background-color="blue">
                    <template slot="chartInsideHeader">
                      <div class="card-icon">
                        <md-icon>timeline</md-icon>
                      </div>
                      <h4 class="title">Industry Branch Concentration (%)</h4>
                    </template>
                  </chart-card>
                </div>
                <div class="md-layout-item md-medium-size-50 md-size-50">
                  <md-card>
                    <md-card-content>
                      <div class="md-card-header md-card-header-icon md-card-header-blue"></div>
                      <h4 class="Performance Scores">
                        Competitive Market Narrative
                      </h4>
                      <p>
                        Is the Plumbing, Heating, and Air-Conditioning Contractors industry becoming subject to outside
                        ownership decisions that could affect the market area? Are local entrepreneurs being squeezed
                        out by franchises or branch operations? The analysis includes an indication based on the percentage
                        of industry branch operations as a barometer of relative consolidation trends. Increasing branch
                        levels may indicate long-term pressure on area entrepreneurship. In this industry market, the
                        percentage of branch operations has increased over the last three years and stands at 6.97%. At 5.91%,
                        national industry consolidation rates are lower and have also increased from 2015.​
                      </p>
                    </md-card-content>
                  </md-card>
                </div>
              </div>
            </template>
          </nav-tabs-card>
        </div>
      </div>
    </div>
  </div>
</template>-->

<script>
import { Collapse } from '@/components';
import { ChartCard, NavTabsCard } from '@/components';
import { mapState } from 'vuex';
import MPHeader from './MPHeader';

export default {
  components: {
    ChartCard,
    NavTabsCard,
    Collapse,
    MPHeader,
  },
 props: ['headerData'],
  data() {
    return {
      showDialog: false,
      tableDataBranchConcentration: [],
      colouredLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          showPoint: true,
          height: '300px',
        },
      },
      filtered_population: [],
      filtered_market_volume: [],
      filtered_market_share: [],
      filtered_annual_sales: [],
      filtered_penetration: [],
      filtered_employment: [],
      filtered_market_by_class: [],
      filtered_market_percent_by_class: [],
      filtered_average_sale_by_class: [],
      filtered_establishment_by_class: [],
      filtered_total_employment_by_class: [],
      filtered_average_employment_by_class: [],
      filtered_annual_sales_per_employee: [],
      filtered_average_annual_wage: [],
      filtered_rent_per_employee: [],
      filtered_startup_info: [],
      filtered_cessation_info: [],
      filtered_ownership_info: [],
      filtered_demographic_info: [],
    };
  },
  computed: {
    ...mapState({
      ownership: (state) => state.user.industryProfile.data['ownership'],
      years: (state) => state.user.industryProfile.firstYears,
      cessation: (state) => state.user.industryProfile.data['cessation'],
      chartData: (state) =>
        state.user.industryProfile.charts.test['Cessation'][0],
      salesEmpSales: (state) =>
        state.user.industryProfile.data['salesEmpSales'],
      salesEmpCols: (state) => state.user.industryProfile['salesEmpCols'],
      salesEmpEmployment: (state) =>
        state.user.industryProfile.data['salesEmpEmployment'],
      tableCompetitors: (state) =>
        state.user.industryProfile.data['competitors'],
      bznaics_code: (state) => state?.user?.industryProfile?.general?.bznaics,
      sector_name: (state) => state?.user?.industryProfile?.general?.sector,
      industry_title: (state) => state?.user?.industryProfile?.general?.industry,
      release_display: (state) =>
        state?.user?.industryProfile?.general?.['release_display'],
      update_month: (state) => state.user.industryProfile.updateMonth,
      display_area: (state) =>
        state?.user?.industryProfile?.general?.area_display_name,
      marketVolume: (state) => state.user.industryProfile.data['marketVolume'],
      marketShare: (state) => state.user.industryProfile.data['marketShare'],
      annualSales: (state) => state.user.industryProfile.data['annualSales'],
      annualSalesCols: (state) => state.user.industryProfile['annualSalesCols'],
      penetration: (state) => state.user.industryProfile.data['penetration'],
      employment: (state) => state.user.industryProfile.data['employment'],
      productivity: (state) =>
        state.user.industryProfile.data['productivityValues'],
      startupPerformance: (state) =>
        state.user.industryProfile.data['startupsValues'],
      startupRates: (state) => state.user.industryProfile.data['startupsIndex'],
      demographics: (state) => state.user.industryProfile.data['demographics'],

      cmnText: (state) =>state.user.cmnText,
      cessation_years: (state) => state?.user?.industryProfile?.general?.cessation_years,
    }),
    cessationLabel() {
      return this.cessation_years && this.cessation_years.length === 2
        ? `${this.cessation_years[0]}-${this.cessation_years[1]} Cessation Rates`
        : 'Cessation Rates';
    },
    getCsvData() {
      let csvData = [
        ['Bizminer Local Industry Market Report'],
        [this.bznaics_code, this.industry_title],
        ['Sector: ' + this.sector_name],
        [
          'Data Time Series',
          this.release_years.toString() + '-' + this.update_month,
        ],
        ['Update Month', this.update_month],
        [''],
      ];
      csvData.push(['Industry Population Analyzed'], ['as of:', this.years]);
      this.filtered_population.forEach((e, i) => {
         if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(
        [''],
        ['Annual Industry Market Volume($)'],
        ['as of:', this.years]
      );
      this.filtered_market_volume.forEach((e, i) => {
        e.forEach((k, i) => {
          if (typeof k === 'string' && k.includes('.')) {
            e[i] = k.replace(/\./g,'');
          }
        });
        csvData.push(e);
      });
      csvData.push([''], ['Share(%)'], ['', this.years]);
      this.filtered_market_share.forEach((e, i) => {
         if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push([''], [''], ['Average Annual Sales']);
      csvData.push(['', this.annualSalesCols]);
      this.filtered_annual_sales.forEach((e, i) => {
         if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Rank'], ['as of:', this.years]);
      csvData.push([''], [''], [''], [''], ['']);
      csvData.push(['Market Penetration ($)']);
      csvData.push(['', this.years]);
      this.filtered_penetration.forEach((e, i) => {
         if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(
        [''],
        [
          'To enhance report load times Sales per Business Establishment values are reported in the IMR-2 file accessible from the My Reports page after you refresh the browser',
        ]
      );
      csvData.push([''], ['']);
      csvData.push(['Employment', this.years]);
      this.filtered_employment.forEach((e, i) => {
         if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push([''], ['']);
      csvData.push(['Market Volume by Employment Class', this.years]);
      this.filtered_market_by_class.forEach((e, i) => {
         if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push(
        [''],
        ['Percent Market Volume by Employment Class', this.years]
      );
      this.filtered_market_percent_by_class.forEach((e, i) => {
         if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Average Sales by Employment Class', this.years]);
      this.filtered_average_sale_by_class.forEach((e, i) => {
         if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Establishments by Employment Class', this.years]);
      this.filtered_establishment_by_class.forEach((e, i) => {
         if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Total Employment by Class', this.years]);
      this.filtered_total_employment_by_class.forEach((e, i) => {
         if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Average Employment by Class', this.years]);
      this.filtered_average_employment_by_class.forEach((e, i) => {
         if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Productivity']);
      csvData.push(['Annual Sales per Employee', this.years]);
      this.filtered_annual_sales_per_employee.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], ['']);
      csvData.push(['Average Annual Wage', this.years]);
      this.filtered_average_annual_wage.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], ['']);
      csvData.push(['Rent per Employee', this.years]);
      this.filtered_rent_per_employee.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], ['']);
      csvData.push(['Productivity Indices (%)', this.years]);
      csvData.push([''], [''], [''], [''], ['']);
      csvData.push(['Startup Activity and Performance']);
      csvData.push(['', this.years]);
      this.filtered_startup_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], [''], ['']);
      csvData.push(
        [
          'To enhance report load times Concentration values are reported in the IMR-2 file accessible from the My Reports page after you refresh the browser',
        ],
        [''],
        [''],
        [''],
        [''],
        [this.cessationLabel]
      );
      this.filtered_cessation_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], ['Ownership/Consolidation Trends', this.years]);
      this.filtered_ownership_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], ['Market Area Demographic Highlights']);
      csvData.push([
        '(based on zip codes co-joined with your market radius) (2015)',
      ]);
      this.filtered_demographic_info.forEach((element, index) => {
        element.forEach((el, i) => {
          csvData.push(el);
        });
        csvData.push(['']);
      });
      return csvData;
    },
  },
  mounted() {
    this.tableDataBranchConcentration = Object.entries(
      this.ownership
    ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));

    this.colouredLineChart.data = {
      labels: this.years,
      series: this.tableDataBranchConcentration.map((item) => ({
        name: item.name,
        data: item.dates.map((i) => Number(i)),
      })),
    };
    let me = this;
    let populationData = Object.entries(this.tableCompetitors).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    populationData.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      this.filtered_population.push(r);
    });

    let marketVolume = Object.entries(this.marketVolume).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    marketVolume.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithCommas(e);
      });
      return item;
    });
    let modifiedArr = [];
    marketVolume.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      modifiedArr.push(r);
    });
    modifiedArr.forEach((el) => {
      let modified = el.map(function (el) {
         if (typeof el === 'string' && el.includes(',')) {
          return el.replace(/,/g, '.');
        }
        return el;
      });
      this.filtered_market_volume.push(modified);
    });
    let marketShare = Object.entries(this.marketShare).map(([table, data]) => ({
      name: table,
      dates: Object.values(data),
    }));
    marketShare.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      this.filtered_market_share.push(r);
    });
    this.filtered_market_share = this.filtered_market_share.filter(
      (item, index) => {
        return !item.includes('Your Firm');
      }
    );
    let tableAnnual = Object.entries(this.annualSales).map(([table, data]) => ({
      name: table,
      dates: Object.values(data),
    }));
    tableAnnual.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    tableAnnual.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      this.filtered_annual_sales.push(r);
    });
    this.filtered_annual_sales = this.filtered_annual_sales.filter(
      (item, index) => {
        if (!item.includes('Your Firm')) {
          return item;
        }
      }
    );
    let penetrationData = Object.entries(this.penetration).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    penetrationData.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    penetrationData.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      this.filtered_penetration.push(r);
    });
    let employmentData = Object.entries(this.employment).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    employmentData.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      this.filtered_employment.push(r);
    });
    this.filtered_employment = this.filtered_employment.filter(
      (item, index) => {
        return !item.includes('Your Firm');
      }
    );
    let marketVolumeByClass = Object.entries(
      this.salesEmpSales.marketVolume
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      marketVolumeByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_market_by_class.push(b);
    });
    let marketPercentVolumeByClass = Object.entries(
      this.salesEmpSales.percentMarket
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      marketPercentVolumeByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_market_percent_by_class.push(b);
    });
    let averageSaleByClass = Object.entries(
      this.salesEmpEmployment.average
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      averageSaleByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_average_sale_by_class.push(b);
    });
    let establishmentByClass = Object.entries(
      this.salesEmpEmployment.establishments
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      establishmentByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_establishment_by_class.push(b);
    });
    let totalEmploymentByClass = Object.entries(
      this.salesEmpEmployment.total
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      totalEmploymentByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_total_employment_by_class.push(b);
    });
    let averageEmploymentByClass = Object.entries(
      this.salesEmpEmployment.average
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      averageEmploymentByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_average_employment_by_class.push(b);
    });
    let annualSalesPerEmployee = Object.entries(
      this.productivity.spe
    ).map(([name, data]) => ({ name, dates: data }));
    annualSalesPerEmployee.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    annualSalesPerEmployee.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_annual_sales_per_employee.push(r);
    });
    this.filtered_annual_sales_per_employee = this.filtered_annual_sales_per_employee.filter(
      (item, index) => {
        return !item.includes('Your Firm');
      }
    );
    let averageAnnualWage = Object.entries(
      this.productivity.annualWage
    ).map(([name, data]) => ({ name, dates: data }));
    averageAnnualWage.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    averageAnnualWage.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_average_annual_wage.push(r);
    });
    this.filtered_average_annual_wage = this.filtered_average_annual_wage.filter(
      (item, index) => {
        return !item.includes('Your Firm');
      }
    );
    let rentPerEmployee = Object.entries(
      this.productivity.rent
    ).map(([name, data]) => ({ name, dates: data }));
    rentPerEmployee.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    rentPerEmployee.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_rent_per_employee.push(r);
    });
    this.filtered_rent_per_employee = this.filtered_rent_per_employee.filter(
      (item, index) => {
        return !item.includes('Your Firm');
      }
    );
    let startupPerformance = Object.entries(this.startupPerformance).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    startupPerformance.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    startupPerformance.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_startup_info.push(r);
    });
    let startupRates = Object.entries(this.startupRates).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    startupRates.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    startupRates.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_startup_info.push(r);
    });
    let cessationRates = Object.entries(this.cessation).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    cessationRates.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_cessation_info.push(r);
    });
    let ownerShip = Object.entries(this.ownership).map(([table, data]) => ({
      name: table,
      dates: Object.values(data),
    }));

    ownerShip.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_ownership_info.push(r);
    });

    let demographicInfo = Object.entries(this.demographics).map(
      ([table, data]) => ({
        name: table,
        data: Object.values(data),
      })
    );
    demographicInfo.forEach((element, index) => {
      this.filtered_demographic_info[index] = [];
      this.filtered_demographic_info[index].push([element.name]);
      element.data.forEach((el, i) => {
        Object.keys(el).forEach((key) => {
          let a = el[key];
          a = a.map((e) => {
             if (typeof e === 'string' && e.includes(',')) {
              return me.numberWithPoints(e);
            } else {
              return e;
            }
          });
          if (!a.includes(key)) {
            a.unshift(key);
          }
          this.filtered_demographic_info[index].push(a);
        });
      });
    });

  },
  methods: {
    numberWithCommas(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      } else {
        return x;
      }
    },
    numberWithPoints(x) {
      if (typeof x === 'number') {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      } else if(x === null){
        return x;
      }else
      {
        return x.replace(/,/g, '.');
      }
    },
    downloadCSVData() {
      let csv = '';
      this.getCsvData.forEach((row) => {
        csv += row.join(',');
        csv += '\n';
      });
      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      anchor.download = 'Industry Market Profile.csv';
      anchor.click();
    },
  },
};
</script>
<style lang="scss">
.marketprof-competitors {
  .md-toolbar {
    .md-collapse {
      display: block;

      .md-collapse-content {
        p {
          padding-left: 20px;
        }
      }
    }
  }

  .competitors-list {
    .md-collapse-title {
      font-size: 12px;
      font-weight: 300;
      margin-left: 25px;
    }
    .md-icon {
      font-size: 12px;
      font-weight: 300;
      transform: rotate(-90deg);
      left: 0;
      color: rgba(0, 0, 0, 0.54);
    }
  }

  .competitors-map {
    iframe {
      height: 300px !important;
    }
  }
}
</style>
